import { CloseOutlined } from '@ant-design/icons';
import { Tag } from 'antd';

function personalTagRender(props) {
    const { label, onClose } = props;
    const onPreventMouseDown = (event) => {
        event.preventDefault();
        event.stopPropagation();
    };
    return (
        <Tag
            onMouseDown={onPreventMouseDown}
            style={{
                marginRight: 3,
                border: '1px solid #E6F7FF',
                background: '#E6F7FF',
                color: '#1890FF',
            }}
            className="rounded"
        >
            <span>{label}</span>
            <span className="ml-2 cursor-pointer" onClick={onClose}>
                <CloseOutlined />
            </span>
        </Tag>
    );
}

function sensitiveRender(props) {
    const { label, onClose, isEdit } = props;
    const onPreventMouseDown = (event) => {
        event.preventDefault();
        event.stopPropagation();
    };
    return (
        <Tag
            onMouseDown={onPreventMouseDown}
            style={{
                marginRight: 3,
                border: '1px solid #3C9393',
                background: '#BAF0F0',
                color: '#3C9393',
            }}
            className="rounded"
        >
            <span>{label}</span>
            {!isEdit && (
                <span className="ml-2 cursor-pointer" onClick={onClose}>
                    <CloseOutlined />
                </span>
            )}
        </Tag>
    );
}

function metaRender(props) {
    const { label } = props;
    const onPreventMouseDown = (event) => {
        event.preventDefault();
        event.stopPropagation();
    };
    return (
        <Tag
            onMouseDown={onPreventMouseDown}
            className="font-semibold text-sm meta-data rounded"
            {...props}
        >
            {label}
        </Tag>
    );
}

const tab3Render = (props) => {
    const { label } = props;

    const onPreventMouseDown = (event) => {
        event.preventDefault();
        event.stopPropagation();
    };

    return (
        <Tag
            onMouseDown={onPreventMouseDown}
            className="text-base text-[#171717] bg-transparent border-none p-0"
        >
            {label}
        </Tag>
    );
};

function metaDataRender(props) {
    const { label } = props;
    const onPreventMouseDown = (event) => {
        event.preventDefault();
        event.stopPropagation();
    };
    return (
        <Tag
            onMouseDown={onPreventMouseDown}
            className="meta-site-tag pt-1 pb-1 pl-3 pr-3 mb-1"
            style={{ backgroundColor: '#E6F7FF' }}
            color="processing"
            icon={
                <>
                    <svg
                        width="11"
                        height="10"
                        viewBox="0 0 11 10"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M5.793 0.293C5.60551 0.105451 5.35119 5.66374e-05 5.086 0H1.5C1.23478 0 0.98043 0.105357 0.792893 0.292893C0.605357 0.48043 0.5 0.734784 0.5 1V4.586C0.500057 4.85119 0.605451 5.10551 0.793 5.293L4.793 9.293C4.98053 9.48047 5.23484 9.58579 5.5 9.58579C5.76516 9.58579 6.01947 9.48047 6.207 9.293L9.793 5.707C9.98047 5.51947 10.0858 5.26516 10.0858 5C10.0858 4.73484 9.98047 4.48053 9.793 4.293L5.793 0.293ZM3 3.5C2.73472 3.49993 2.48033 3.39449 2.29279 3.20686C2.10525 3.01923 1.99993 2.76478 2 2.4995C2.00007 2.23422 2.10551 1.97983 2.29314 1.79229C2.48077 1.60475 2.73522 1.49943 3.0005 1.4995C3.26578 1.49957 3.52017 1.60501 3.70771 1.79264C3.89525 1.98027 4.00057 2.23472 4.0005 2.5C4.00043 2.76528 3.89499 3.01967 3.70736 3.20721C3.51973 3.39475 3.26528 3.50007 3 3.5Z"
                            fill="#1890FF"
                        />
                    </svg>
                    <span> </span>
                </>
            }
            closeIcon={
                <svg
                    width="9"
                    height="8"
                    viewBox="0 0 9 8"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M5.07808 3.99972L8.00776 0.507534C8.05687 0.449498 8.01558 0.361328 7.93968 0.361328H7.04906C6.9966 0.361328 6.94638 0.384766 6.91178 0.424944L4.49549 3.30552L2.07919 0.424944C2.04571 0.384766 1.99549 0.361328 1.94191 0.361328H1.05129C0.975396 0.361328 0.934102 0.449498 0.983209 0.507534L3.9129 3.99972L0.983209 7.49191C0.972208 7.50484 0.965151 7.52067 0.962875 7.53749C0.960598 7.55432 0.963198 7.57145 0.970367 7.58684C0.977535 7.60223 0.98897 7.61525 1.00331 7.62434C1.01766 7.63343 1.03431 7.63821 1.05129 7.63811H1.94191C1.99437 7.63811 2.04459 7.61468 2.07919 7.5745L4.49549 4.69392L6.91178 7.5745C6.94526 7.61468 6.99549 7.63811 7.04906 7.63811H7.93968C8.01558 7.63811 8.05687 7.54994 8.00776 7.49191L5.07808 3.99972Z"
                        fill="#1890FF"
                    />
                </svg>
            }
            {...props}
        >
            {label}
        </Tag>
    );
}

export {
    personalTagRender,
    sensitiveRender,
    metaRender,
    tab3Render,
    metaDataRender,
};
